
import useSession from "hooks/useSession";
import { NameRegister, IdRegister, PhoneRegister, BirthdayRegister, UiToast, PreferencesRegister, ConfirmRegister, UiModal, IdDuplicated, AgeConfirmation, PPostalAddressRegister } from "libs/raas-ui-react-components/src/components"
import { useState } from "react"
import { useNavigate } from "react-router-dom";
import { putAxios, deleteAxios } from "services/api/api.service";
import { apiNames } from "services/api/endpoint.service";
import { closeSession, IUserData, RaaSSession, SessionStorageItems } from "services/user/user.session.service";
import { removeItemStorage } from "services/util/sessionStorage.service";
import { birthdayRegisterLiterals, confirmRegisterLiterals, formatDate, formatPreferences, idDuplicatedLiterals, idRegisterLiterals, nameRegisterLiterals, phoneRegisterLiterals, postalAddressRegisterLiterals, preferencesRegisterLiterals } from "./Onboarding.util";
import { IPostalAddressData } from "./Onboarding.model";
import { useTranslation } from "react-i18next";
import { LocalRoutes } from "local-routes";
import { mappingScreenNameAnalytics } from "services/util/util.service";
declare const window: any;
export const OnBoardingFlow = () => {
  const [t] = useTranslation('onBoarding');
  const [t2] = useTranslation('preferences');
  const navigate = useNavigate();
  const { setSession, setLogged, setUserConnected, setStepOnBoarding } = useSession();

  const [step, setStep] = useState(0);
  const [namePageData, setNP] = useState({})
  const [idPageData, setId] = useState({ type: "DNI", value: "" })
  const [phonePageData, setPP] = useState({ phoneNumber: "", prefixNumber: "ESP (+34)" })
  const [birthDateData, setBD] = useState({});
  const [addressData, setAddress] = useState({ streetAddress: '', postalCode: '', locality: '', region: '', country: '' } as IPostalAddressData);
  const [under16, setUnder16] = useState(true);
  const [confirmacion, setConf] = useState(false);


  const [prefGlobalData, setPD] = useState(t("literals.direct") as any)

  const [showError, setShowError] = useState(false);
  const [showDuplicateIDModal, setShowModal] = useState(false);
  const [showConfirmationIDModal, setShowModalAge] = useState(false);
  const [msgError, setSMessageE] = useState("");
  const [titleError, setTitle] = useState("");
  const [typeError, setTypeError] = useState("");


  const getStepOnBoardingComponent = (s: number) => {
    switch (s) {
      case 0:
        setStepOnBoarding(false);
        return <NameRegister
          literals={nameRegisterLiterals(t)}
          nameObj={namePageData}
          onNextPage={(data) => { handleStep(s, data) }}
          onExitPage={() => { handleExit() }}
        />;

      case 1:
        return <IdRegister
          literals={idRegisterLiterals(t)}
          valueinput={idPageData}
          onNextPage={(data) => { handleStep(s, data) }}
          onExitPage={() => { handleExit() }}
          onBackPage={() => { handleBackStep(s) }}
        />;

      case 2:
        return <PhoneRegister
          literals={phoneRegisterLiterals(t)}
          valueData={phonePageData}
          onNextPage={(data) => { handleStep(s, data) }}
          onExitPage={() => { handleExit() }}
          onBackPage={() => { handleBackStep(s) }}
        />;

      case 3:
        return <BirthdayRegister
          literals={birthdayRegisterLiterals(t)}
          birthValues={birthDateData}
          onNextPage={(data) => { handleStep(s, data) }}
          onExitPage={() => { handleExit() }}
          onBackPage={() => { handleBackStep(s) }}
        />;

      case 4:
        return <PPostalAddressRegister
          literals={postalAddressRegisterLiterals(t)}
          data={addressData}
          onNextPage={(data) => { handleStep(s, data) }}
          onBackPage={() => { handleBackStep(s) }}
        />;
      case 5:
        return <PreferencesRegister
          literals={preferencesRegisterLiterals(t)}
          valueSwitch={prefGlobalData}
          onNextPage={(data) => { handleStep(s, data) }}
          onExitPage={() => { handleExit() }}
          onBackPage={() => { handleBackStep(s) }}
        />;

      case 6:
        setStepOnBoarding(true);
        return <ConfirmRegister
          literals={confirmRegisterLiterals(t)}
          image={{
            name: 'exito_cuenta_creada',
            width: '416px',
            height: '416px'
          }}
          onNextPage={(data) => { handleStep(s, data) }}
          onExitPage={() => { handleExit() }}
        />;
    }
  }

  const handleExit = () => {
    navigate(-1);
  }

  const handleBackStep = (step: number) => {
    setStep(step - 1);
  }

  const handleStep = (step: number, data?: any) => {
    switch (step) {
      case 0:
        setNP(data.detail);
        setStep(step + 1);
        break;
      case 1:
        let mapping={
            value:data.detail.value,
            type:data.detail.type
        }
        setId(mapping);
        apiRequiredIDCall(data.detail, () => {
          setStep(step + 1)
        })
        break;
      case 2:
        let phoneNumberData = { prefixNumber: getPrefixNumber(data.detail.prefixNumber), phoneNumber: data.detail.phoneNumber };
        setPP(phoneNumberData)
        apiRequiredCall(phoneNumberData, () => {
          setStep(step + 1)
        })
        break;
      case 3:
        setConf(false);
        handleClickButtons(data);
        break;
      case 4:
        setAddress(data.detail);
        apiAddressCall(data.detail, () => {
          setStep(step + 1);
        })
        break;
      case 5:
        setPD(data.detail);
        apiOptionalUserCall(() => { // Consultar con Isma ¿No tendría que estar en el case 3?
          apiOptionalPreferencesCall(data.detail, () => {
            setStep(step + 1)
          })
        })
        break;
      case 6:
        navigate("/my-profile");
        break;
    }
    ;
  }
  const   getPrefixNumber =(text: string)=> {
    let primerParentesis=0;
    let segundoParentesis=0;
    for (let index = 0; index < text.length; index++) {
      if(text[index]==="("){
      primerParentesis=index+2;
      }else if(text[index]===")"){
      segundoParentesis=index
      }
    }
    return text.substring(primerParentesis, segundoParentesis);
  }
  const verifyUnder16 = (data: any): boolean => {
    let currentDate = new Date();
    let birthDate = new Date(data.detail.year, data.detail.month - 1, data.detail.day);
    if ((currentDate.getFullYear() - birthDate.getFullYear()) < 16) {
      return true;
    }
    else if ((currentDate.getFullYear() - birthDate.getFullYear()) === 16) {
      if ((currentDate.getMonth() < birthDate.getMonth())) {
        return true;
      }
      else if (currentDate.getMonth() === birthDate.getMonth()) {
        if ((currentDate.getDate() < birthDate.getDate())) {
          return true;
        }
        else if (currentDate.getDate() >= birthDate.getDate()) {
          return false;
        }
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
    // Por default. Nunca deberia llegar aqui.
    return true;
  }
  const handleClickButtons = (data?: any) => {
    /* BOTÓN OMITIR PASO */
    if (data.detail === 'Skip') {
      setBD({});
      setShowModalAge(true);
    }
    /* BOTON CONTINUAR (CON LOS CAMPOS DEL CUMPLE RELLENOS) */
    else {
      setBD(data.detail);
      const isUnder16 = verifyUnder16(data);
      setUnder16(isUnder16);

      if (isUnder16) {
        setConf(true);
        setShowModalAge(true);
        window.dataLayer?.push({
          event:"page_view",
          screen_name: 'under_legal_age_alert',
          screen_class: mappingScreenNameAnalytics(window.location.pathname),
        });
      }
      else {
        setStep(step + 1);
      }
    }
  }

  const apiRequiredIDCall = (idData: any, callback: Function) => {
    setShowModal(false);
    let body = { identificationDocument: idData };
    if (body?.identificationDocument?.type === "Pasaporte") body.identificationDocument.type = "PASS";
    putAxios(apiNames.PROFMANAG, true, "/customers/profiles", body).then((response: any) => {
      callback(response);
    }).catch(errorIDApi)
  }

  const apiRequiredCall = (phoneNumberData: any, callback: Function) => {
    putAxios(apiNames.PROFMANAG, true, "/customers/profiles", {
      customerFullName: namePageData,
      phone: { number: phoneNumberData.phoneNumber, prefix: "+" + phoneNumberData.prefixNumber },
    }).then((response: any) => {
      callback(response);
    }).catch(errorFunction)
  }

  const apiOptionalUserCall = (callback: Function) => {
    if (birthDateData === "Skip") {
      callback()
    } else {
      putAxios(apiNames.PROFMANAG, true, "/customers/profiles", {
        under16: under16,
        birthDate: JSON.stringify(birthDateData) !== '{}' ? formatDate(birthDateData) : undefined
      }).then((response: any) => {
        callback(response);
      }).catch(errorFunction)
    }

  }
  const apiAddressCall = (data: IPostalAddressData, callback: Function) => {
    putAxios(apiNames.PROFMANAG, true, "/customers/profiles", {
      mailingAddress: data
    }).then((response: any) => {
      callback(response);
    }).catch(errorFunction)
  }

  const apiOptionalPreferencesCall = (data: any, callback: Function) => {
    let body = { preferences: {} } as any;
    let callApi: boolean = false;
    if (data !== "Skip") {
      callApi = true;
      body.preferences.optimalRoutes = formatPreferences(data,t2);
    }
    if (callApi) {
      putAxios(apiNames.PROFMANAG, true, "/customers/profiles/preferences", body)
        .then((response: any) => {
          callback(response);
        }).catch(errorFunction)
    } else {
      callback();
    }
  }

  const deleteAccount = (callback: Function) => {
    deleteAxios(apiNames.IDENTITY, true, "/customers/accounts").then((response: any) => {
      // TODO - SESSION CLOSE, REMAKE THE USE SESSION, WITH ALL THIS 3 LINES.
      setLogged(false);
      setSession({} as RaaSSession);
      setUserConnected({} as IUserData);
      removeItemStorage(SessionStorageItems.RAAS_USER);

      closeSession();

      callback(response);
    }).catch((error: any) => {
      callback(error);
    })
  }

  const errorIDApi = (error: any) => {
    if (error?.status === 409) {
      setShowModal(true);
      window?.dataLayer?.push({
        event: "page_view",
        screen_name: "repeat_doc_alert",
        screen_class: mappingScreenNameAnalytics(window.location.pathname)
      });
    } else {
      errorFunction(error);
    }
  }

  const errorFunction = (error: any) => {
    if (error?.status === 401) {
      setTitle(t("literals.error"));
      setSMessageE(t("literals.tokenHasExpired"))
      setTypeError("error");
      setShowError(true);
    } else if (Math.floor(error?.status / 100) === 4) {
      if (error?.data?.errors?.[0]?.code == "ERROR_APP_CUSTADMIN_PROFILES_013") { // "Invalid identification document"
        setTitle(t("literals.error"));
        setSMessageE(t("literals.errorIdentificationDocument"))
        setTypeError("error");
        setShowError(true);
      } else {
        setTitle(t("literals.error"));
        setSMessageE(t("literals.errorTryAgainLater"))
        setTypeError("error");
        setShowError(true);
      }
      setTypeError("error");
      setShowError(true);
      // window?.dataLayer?.push({ // Duda incluir o no.
      //   event: "page_view",
      //   screen_name: "personal_information_id",
      //   screen_class: "error_personal_information_id"
      // });
    }
  }

  const handleToastClick = () => {
    setShowError(false);
  }

  const handleRessetPassword = () => {
    deleteAccount(() => {
      setShowModal(false);
      navigate("/reset-password")



    })
  }

  const hadleAssist = () => {
    deleteAccount(() => {
      window.location.pathname = "/ayuda";
      setShowModal(false);
    })
  }

  const handleCloseModal = () => {
    setShowModal(false);
  }

  const handleCloseModalAge = () => {
    setShowModalAge(false);
    setUnder16(false);
    setStep(step + 1);
  }

  const handleUnderstoodClick = () => {
    setShowModalAge(false);
    setUnder16(true);
    //setStep(step + 1);
  }


  return (
    <>
      <UiToast onHandleClickToast={handleToastClick} textTitle={titleError} textDesc={msgError} type={typeError} visible={showError}></UiToast>
      {getStepOnBoardingComponent(step)}
      <UiModal open={showDuplicateIDModal}>
        <IdDuplicated
          literals={idDuplicatedLiterals(t)}
          onNeedAssist={hadleAssist}
          onNewPassword={handleRessetPassword}
          onCloseModal={handleCloseModal}
        />
      </UiModal>
      <UiModal open={showConfirmationIDModal} blockOverlay={true}>
        <AgeConfirmation
          literals={{
            title: t("literals.title"),
            description: t("literals.description"),
            buttonText: t("literals.buttonText"),
            secondaryButtonText: t("literals.secondaryButtonText"),
            confirmationButton: t("literals.confirmationButton"),
          }}
          confirmation={confirmacion}
          onUnderstood={handleUnderstoodClick}
          onCloseModal={handleCloseModalAge}
        />
      </UiModal>
    </>
  )
}

